// extracted by mini-css-extract-plugin
export default {"custom-scrollbar":"scrollbar_custom-scrollbar__yMwsV","scroll-auto-hide":"scrollbar_scroll-auto-hide__CNFbt"};